import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    filtersPanel: {
      [theme.breakpoints.up('xl')]: {
        width: 300,
      },
    },
    sortWrapper: {
      display: 'none',
    },
  }),
);

export default useStyles;
